import block from './block.json';

export const paginationThemeAttributes = {
	margin: {
		top: [20, 40],
		bottom: [20, 40],
	},
	grid: {
		gap: [10, 10],
	},
	number: {
		backgroundColor: '@tokens.variants.default.buttonBackgroundColor',
		width: [15, 20],
		height: [15, 20],
		border: {
			color: '@tokens.variants.default.buttonBorderColor',
			width: {
				top: [1, 1],
				right: [1, 1],
				bottom: [1, 1],
				left: [1, 1],
			},
			radius: {
				topLeft: [0, 0],
				topRight: [0, 0],
				bottomRight: [0, 0],
				bottomLeft: [0, 0],
			},
		},
		color: '@tokens.variants.default.buttonTitleColor',
		typography: '@tokens.typographies.introduction',
		textAlignment: 'left',
	},
	link: {
		backgroundColor: '@tokens.variants.default.buttonBackgroundColor',
		border: {
			color: '@tokens.variants.default.buttonBorderColor',
			width: {
				top: [0, 0],
				right: [0, 0],
				bottom: [0, 0],
				left: [0, 0],
			},
			radius: {
				topLeft: [0, 0],
				topRight: [0, 0],
				bottomRight: [0, 0],
				bottomLeft: [0, 0],
			},
		},
		color: '@tokens.variants.default.buttonTitleColor',
		typography: '@tokens.typographies.introduction',
		textAlignment: 'left',
	},
	states: {
		hover: {}, // adds hover state
		active: {}, // adds active state
	},
};

export const PaginationThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: paginationThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
